import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";
import UserBox from "./user_box";

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    wallsCommentId: PropTypes.number.isRequired,
  },
  getInitialState() {
    return {
      users: [],
    };
  },
  loadLikeUsers() {
    $.ajax({
      url: "/api/walls/walls_comments_like_users",
      type: "GET",
      cache: false,
      data: {
        walls_comment_id: this.props.wallsCommentId,
      },
      contentType: false,
    })
      .done(
        function(data) {
          this.setState({
            users: data.users,
          });
        }.bind(this)
      )
      .fail(function() {}.bind(this));
  },
  componentDidMount() {
    this.loadLikeUsers();
  },
  render() {
    const users = this.state.users.map(function(user) {
      return <UserBox key={user.id} user={user} />;
    });

    return (
      <div>
        <div className="container col-md-8 col-lg-6 p-4">
          <h2 className="h2 h2--extend -member2">
            いいねしたユーザー<span className="text-fz-14px" />
          </h2>
        </div>
        <hr className="m-0" />
        <div className="container col-md-8 col-lg-6">
          <ul className="mb-3_5 list-unstyled">{users}</ul>
        </div>
      </div>
    );
  },
});
